import React, { useEffect, useState } from 'react'
import { FullPageSpinner } from '../common/Spinner/FullPageSpinner'
import { useGetOrgLicensedProducts } from '../../hooks/ReactQueryHooks/useGetOrgLicensedProducts';
import { Button } from '../common/Button';
import CallIcon from "../../assets/images/call-border.png"
import labIcon from '../../assets/images/chemistry.png';
import medicalIcon from '../../assets/images/medical-prescription.png';
import diagnosticIcon from '../../assets/images/analytics.png';
import referralIcon from '../../assets/images/referral.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { failed, success } from '../common/Toastify';
import { useSelector } from 'react-redux';
import { getOrganization } from '../api/Organization';
import SelectFiled from '../common/textfield/SelectFiled';
import { QuestionnaireFormikObj } from './constant';
import { isAnswered, evaluateCondition } from '../../utils/questionnaireSupport';
import { useFormik } from 'formik';
import {
  createQuestionnaireResponse,
  editQuestionnaireResponse,
  getSavedQuestionnaireResponses,
  getVideoVisitQuestionnaire,
  getQuestionnaireById
} from '../api/Questionnaire';
import "./PhoneCallCreate.css"
import { editQueueItem, endWaitingRoomMeeting } from '../apps/api/WaitingRoom';
import { axios } from '../../lib/axios';
import moment from 'moment';
import {
  editEncounter,
  getEncounterRecord,
  getQueueRecord,
  updateAppointmentRequest,
  getEncounterQuestionnaireResponses
} from '../apps/api/AppointmentRequests';
import { getPatientData, getSingleUser } from '../api/Individual';
import QuestionnaireRenderer from '../Admin/Questionnaire/QuestionnaireRenderer'
import { useEncounterQuestionnaireResponseQuery } from '../../hooks/ReactQueryHooks/useQuestionnaireResponseQuery';
import ScheduleAppointmentWR from '../apps/Queue/ScheduleAppointmentWR';
import EncounterDetail from "../apps/Patient/EncounterDetail";
import { createProtocolResponse, getProtocolResponsesByEncounterId } from '../apps/api/Protocol';
import TriageParentComponent from '../apps/Protocol/TriageParentComponent';
import { capitalizeWords } from '../../utils/capitalizeWords';
import { safeAgeString, ViewDate } from '../../utils/DateSupport';
import { Resources } from './Resources';
import { useConfirmDialog } from '../../hooks/useConfirmDialog'
import isEqual from 'lodash/isEqual';
import { getServiceLineById } from '../api/ServiceLine';
import { enc } from 'crypto-js';
import { syncMissingParticipantsFromStatusHistory } from '../../utils/EncounterSupport';

function PhoneCallCreate() {
  const { state } = useLocation();
  const {
    encounterId,
    currentUser,
    practitionerName,
    appointmentData,
    practitionerId,
    patientId,
    patientName,
    proceedWith,
    requestedPeriod,
    period,
    questionnairInfo,
    previousStatus,
    callInitiatedFrom
  } = state;
  const { getConfirmation } = useConfirmDialog();
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const orgId = adminOrgs?.[0]?.id;
  const user = useSelector((state) => state?.auth?.user);
  const userRoles = user?.["cognito:groups"];
  const admin = userRoles?.includes('Super-Admin');
  const permissions = user?.permissions;
  const practUserName = user?.name?.[0]?.text;
  const hasResourcesReadPermissions = admin || permissions.some(permission => permission === 'Access Resource Hub')
  const [encounterDetailsShow, setEncouterDetailsShow] = useState(false);
  const [encounterFinished, setEncounterFinished] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [organization, setOrganization] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [textEditorKey, setTextEditorKey] = useState(0);
  const [buttonText, setButtonText] = useState("Save")
  const [questionnaireList, setQuestionnaireList] = useState([]);
  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState('');
  const [savedQuestionnaireResponses, setSavedQuestionnaireResponses] = useState([]);
  const [savedQuestionResponseId, setSavedQuestionResponseId] = useState('');
  const [currentSessionSavedQRId, setCurrentSessionSavedQRId] = useState([]);
  // NEW: Whether the *current user* can edit the *selected questionnaire*
  const [canEditSelectedQuestionnaire, setCanEditSelectedQuestionnaire] = useState(true);

  const [practionerData, setPractionerData] = useState({});
  const [myUserId, setMyUserId] = useState("");
  const [encounterRecord, setEncounterRecord] = useState({});
  const [intakeQuestionnaireId, setIntakeQuestionnaireId] = useState("");
  const [queueRecord, setQueueRecord] = useState({});

  const { data: orgLicensedProducts } = useGetOrgLicensedProducts({});
  const isVirtualCare = admin ? false : orgLicensedProducts?.virtualCare;
  const isContactCenterActive = orgLicensedProducts?.callCenter;
  const [triageBtnState, setTriageBtnState] = useState(true);
  const [patientData, setPatientData] = useState(null);
  const [showTriageComponent, setShowTriageComponent] = useState(false);
  const [protocolResponseWasUpdated, setProtocolResponseWasUpdated] = useState(false);
  const [resourceModalShow, setResourceModalShow] = useState(false)

  const navigate = useNavigate();
  const [scheduleAppointmentModalOpen, setScheduleAppointmentModalOpen] = useState(false);
  const [intakeQuestionnaire, setIntakeQuestionnaire] = useState([]);
  const [intakeQuestionnaireDefinition, setIntakeQuestionnaireDefinition] = useState(null);
  const [intakeQuestionResponse, setIntakeQuestionResponse] = useState([]);
  const [isIntakeQuestionnaire, setIsIntakeQuestionnaire] = useState(false);
  const [initialQuestionnaireResponse, setInitialQuestionnaireResponse] = useState([]);
  const [isQuestionnaireCompleted, setIsQuestionnaireCompleted] = useState(false);
  const [isReleaseDisabled, setIsReleaseDisabled] = useState(false);
  const formik = useFormik({
    ...QuestionnaireFormikObj,
    onSubmit: (values, { setErrors, setFieldValue }) => {
      return new Promise((resolve, reject) => {
        if (!values.questionResponse || values.questionResponse.length === 0) {
          failed("Save questionnaire before proceeding");
          return;
        }
        const currentQuestionnaire = isIntakeQuestionnaire 
            ? intakeQuestionnaireDefinition 
            : questionnaireList.find(q => q.id === selectedQuestionnaire);
            
        for (let i = 0; i < values?.questionResponse.length; i++) {
            const item = values?.questionResponse[i];
            
            
            const questionnaireItem = currentQuestionnaire?.item?.find(q => q.id === item.questionId);
            const isVisible = !questionnaireItem?.enableWhen || 
                            evaluateCondition(questionnaireItem.enableWhen.expression, values.questionResponse);
            
            
            if (isVisible && item.required && !isAnswered(item)) {
                setErrors({ isQuestionsError: `Question : ${item.question} is mandatory.` });
                return;
            }
        }
        setBtnLoading(true);
        setIsDisabled(false);

        let QRid = values.questionResponseId;

        const requestBody = {
          patientID: patientId,
          encounterId: encounterId,
          questionResponse: values.questionResponse,
          appointmentId: "",
          questionnaire: selectedQuestionnaire,
          authorName: user?.name?.[0]?.text,
          authorType: "Practitioner",
          authorId: user["custom:practitioner_id"]
        };
           
          if(QRid){
            //Update Questionnaire Response
            editQuestionnaireResponse(QRid, requestBody)
                .then(async (res) => {
                    try {
                        setFieldValue("questionResponseId", res.data.id)
                        const responses = await getEncounterQuestionnaireResponses({ encounterId });
                        setSavedQuestionnaireResponses(responses); 
                        setInitialQuestionnaireResponse(values?.questionResponse);
                        success(res.message);
                        setIsQuestionnaireCompleted(true);
                        resolve(res);
                    } catch (error) {
                        console.error("Error fetching questionnaire responses:", error);
                    }
                })
                .catch((error) => {
                  failed(
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error.message
                  );
                  reject(error);
                })
                .finally(() => setBtnLoading(false));
          } else{ 
              //Create a New Questionnaire Response
              createQuestionnaireResponse(requestBody)
              .then(async (res) => {
                  setFieldValue("questionResponseId", res.data.id) 
                  const responses = await getEncounterQuestionnaireResponses({ encounterId });
                  setSavedQuestionnaireResponses(responses); 
                  if (previousStatus === "follow-up" && !currentSessionSavedQRId.includes(selectedQuestionnaire)) {
                    setCurrentSessionSavedQRId(prevIds => [...prevIds, selectedQuestionnaire]);
                  } 
                  setButtonText("Update");
                  setInitialQuestionnaireResponse(values?.questionResponse);  
                  success(res.message);
                  setIsQuestionnaireCompleted(true);
                  resolve(res);
              })
              .catch((error) => {
                failed(
                  error?.response?.data?.message ||
                  error?.response?.data?.error ||
                  error.message
                );
                reject(error);
              })
              .finally(() => setBtnLoading(false));
          }
      });
    }
  });

  // Listen for browser back button to go to dashboard instead of recreating session
  useEffect(() => {
    const handlePopState = () => {
      navigate('/app/dashboard', { replace: true });
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  // Fetch current user's Practitioner info
  useEffect(() => {
    const apiBody = {
      id: user?.["custom:unique_id"],
      type: "Practitioner",
      userOrgId: adminOrgs?.[0]?.id
    };
    getSingleUser(apiBody)
      .then((res) => {
        setPractionerData(res?.data);
        setMyUserId(res?.data?.link?.[0]?.target?.reference?.split("/")?.[1]);
      })
      .catch((err) => {
        console.log("error in getSingleUser:", err)
      });
    return () => {
    };
  }, []);

  useEffect(() => {
      if (patientId) {
        getPatientData(patientId)
          .then((res) => {
            if (res?.status === true) {
              setPatientData(res?.result);
            }
          })
          .catch((res) =>
            failed(
              res?.response?.data?.message ||
                res?.response?.data?.error ||
                res.message
            )
          )
      }
    }, [patientId]);

  // Encounter record + queue record
  useEffect(() => {
    getEncounterRecord({ encounterId })
      .then((res) => {
        setEncounterRecord(res?.data);
        let iQID = res?.data?.intakeQuestions?.questionnaireResponseId?.reference.split("/")?.[1];
        setIntakeQuestionnaireId(iQID)
        if (res?.data?.id) {
          getQueueRecord({ encounterId, userOrganizationId: orgId })
            .then((res) => {
              if (res?.data?.id) setQueueRecord(res?.data);
            });
        }
      });
  }, [encounterId, orgId]);

  useEffect(() => {
    // Disable release if questionnaire is saved or triage is launched
    if (isQuestionnaireCompleted || protocolResponseWasUpdated || callInitiatedFrom === "inboundCall") {
      setIsReleaseDisabled(true);
    }
  }, [isQuestionnaireCompleted, protocolResponseWasUpdated, callInitiatedFrom]);


  const handleReleaseEncounter = async () => {
  // Show confirmation dialog
  const confirmed = await getConfirmation({
    title: "Release Encounter",
    message: "Are you sure you want to release the encounter and return it to the queue?",
    actionBtnTitle: "Yes"
  });
  

  if (!confirmed) {
    return;
  }

  setIsLoading(true);
  setLoadingText("Releasing Encounter...");
  

  try {
    
    let returnStatus = previousStatus;
    const currentActor = {
      reference: `Practitioner/${myUserId}`,
      display: practUserName,
      type: "Practitioner",
    };
 
    const encounterRes = await getEncounterRecord({ encounterId });
    const encounterResult = encounterRes?.data; 
    const existingStatusHistory = encounterResult?.statusHistory || [];

    // Close the current "in-progress" period
    const updatedStatusHistory = existingStatusHistory.map(entry => {
      if (entry.status?.startsWith("in-progress") && !entry.period?.end) {
        return {
          ...entry,
          period: {
            ...entry.period,
            end: new Date().toISOString().split('.')[0] + '.00Z'
          }
        };
      }
      return entry;
    });
    
    if(returnStatus == "arrived" && encounterResult?.proceedWith !== "WAITING_ROOM"){
      const statusHistoryEntry = {
        status: returnStatus,
        period: {
          start: new Date().toISOString().split('.')[0] + '.00Z',
          end: null
        },
        actor: currentActor
      };
      updatedStatusHistory.push(statusHistoryEntry); 
    }

    const encounterPayload = {
      patient: encounterResult?.subject,
      orgId: encounterResult?.orgId,
      orgName: encounterResult?.serviceProvider?.display || encounterResult?.managingOrganization?.display,
      questionnairInfo: encounterResult?.intakeQuestions,
      requestedPeriod: encounterResult?.requestedPeriod,
      practitionerId: encounterResult?.practitionerId,
      practitionerName: practUserName,
      proceedWith: encounterResult?.proceedWith,
      status: returnStatus,
      encounterId: encounterResult?.id,
      patientLocation: encounterResult?.patientLocation,
      participant: encounterResult?.participant,
      actor: currentActor,
      encounterClass: "NULL",
      statusHistory: updatedStatusHistory
    };

    const res = await editEncounter(encounterPayload);

    success("Encounter released successfully");
    organization?.isWaitingRoom ? navigate('/app/waiting-room', { replace: true }) :
     navigate('/app/dashboard', { replace: true });
  } catch (error) {
    failed(
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error.message ||
      "Failed to release encounter"
    );
  } finally {
    setIsLoading(false);
    setLoadingText("");
  }
};

  // For Add Lab, Diagnostics, etc.
  const handleServiceRequest = (requestType) => {
    window.open(
      `/app/service-request?encounterId=${state?.encounterId}&patientId=${patientId}&requestType=${requestType}&fromPatient=false`,
      '_blank'
    );
  };
  const handleMedicationRequest = () => {
    window.open(
      `/app/encounter-medication-request?encounterId=${state?.encounterId}&practitionerId=${practitionerId}&patientId=${patientId}&fromPatient=false`,
      '_blank'
    );
  };

  // Converts the questionnaire definition to a fresh local question array
  const setEmptyQuestionnaire = (qId) => {
    const found = questionnaireList.find((item) => item.id === qId);
    if (!found || !Array.isArray(found?.item)) return [];
    return found.item.map((item, index) => ({
      id: item.linkId,
      questionId: item?.id || null,
      tag: item?.tag,
      // answerId: item.id,
      question: item.text,
      key: { index },
      questionType: item.answerType,
      answerType: item.answerType,
      answerOption: item.answerOption?.map((x) => ({
        value: x.value ?? x.text,
        name: x.text ?? x.value,
        text: x.text,
        option: x.value ?? x.text
      })),
      answer: item.answerOption?.map((ans) => ({
        answer: "",
        id: ans?.id,
        option: ans?.value ?? ans?.text
      })),
      required: item?.required,
    }));
  };

  // Converts an existing DB-saved response to a local array
  const setPreviousQuestionnaire = (qResponse) => {
    return qResponse?.item?.map((questionItem, index) => ({
      id: questionItem.linkId,
      questionId: questionItem?.questionId || questionItem?.id || questionItem?.linkId || null,
      // answerId: questionItem.answerId,
      question: questionItem.text,
      tag: questionItem?.tag,
      key: { index },
      questionType: questionItem.questionType,
      answerType: questionItem.questionType,
      answerOption: questionItem?.answer?.map((x) => ({
        value: x?.option,
        name: x?.option,
        text: x?.option,
        option: x?.option
      })),
        answer: questionItem?.answer?.map((ans) => ({
        answer: ans?.valueString || ans?.ratingText || ans?.valueBoolean || "",
        id: questionItem?.linkId,
        questionId: questionItem?.questionId || questionItem?.id || questionItem?.linkId || null,
        option: ans?.option || ans?.valueString
      })),
      required: questionItem?.required,
    }));
  };

  // Check if current user can edit the existing questionnaire response
  const checkCanEditAuthor = (responseObj) => {
    if (!responseObj?.author?.reference || !user) return true;
    const authorRef = responseObj.author.reference; // e.g. "Practitioner/12345..."
    const authorId = authorRef.split("/")[1];
    // Return true if the same as current user, false if not
    return authorId === user?.["custom:practitioner_id"];
  };

  const handlePrompt = async (event) =>{
          const selectedQId = event.target.value;
          if(!isEqual(initialQuestionnaireResponse ,formik.values.questionResponse)){
              const confirmed = await getConfirmation({
                  title: "Attention!",
                  message: "You have unsaved changes. Are you sure you want to lose your unsaved changes?",
                  actionBtnTitle: "Continue anyway"
              });
      
              if (confirmed) {
                  
                  handleSelectChange(selectedQId)
              }
  
          }else{
              handleSelectChange(selectedQId)
          }
      }

  // When user selects from the "Select Questionnaire" dropdown
  const handleSelectChange = async (selectedQId) => {
    if(selectedQId === 'Intake Questions'){
      setIsIntakeQuestionnaire(true)
      setSelectedQuestionnaire(selectedQId);
      setCanEditSelectedQuestionnaire(false)

      if (intakeQuestionResponse && intakeQuestionResponse.length > 0) {
        formik.setFieldValue("questionResponse", intakeQuestionResponse);
        setInitialQuestionnaireResponse(intakeQuestionResponse);
      } else {
        formik.setFieldValue("questionResponse", []);
        setInitialQuestionnaireResponse([]);
      }
      return;
    }
    setIsIntakeQuestionnaire(false)
    let questionResponse = [];
    let canEdit = true; // default to true, refine below if a different author is found
    setButtonText("Save");
    formik.setFieldValue("questionResponseId", null); 
    try {
      // PreviousStatus => follow-up and have not saved this selectedQId
      if (previousStatus === "follow-up" && !currentSessionSavedQRId.includes(selectedQId) ) {  
        questionResponse = setEmptyQuestionnaire(selectedQId);
      } else {
         // Attempt to find the latest DB-saved questionnaireResponse for that Q
         let latestResponse = null;
         if (savedQuestionnaireResponses && savedQuestionnaireResponses.data) {
             const filteredData = savedQuestionnaireResponses.data
             .filter((r) => r.questionnaire === selectedQId)
             .sort((a, b) => b.authored - a.authored); // newest first
             latestResponse = filteredData.length > 0 ? filteredData[0] : null;
         }

         if (latestResponse?.item?.length > 0) {
             // We have an existing response in DB for that Q
             canEdit = checkCanEditAuthor(latestResponse);
             if (!canEdit) {
                 // Different author => new blank 
                 questionResponse = setEmptyQuestionnaire(selectedQId);
                 setButtonText("Save");
             } else { 
                 // Same author => load the existing data
                 questionResponse = setPreviousQuestionnaire(latestResponse);
                 formik.setFieldValue("questionResponseId", latestResponse.id);
                 setButtonText("Update"); 
              }
         } else {
            // There's no existing response => brand new 
            questionResponse = setEmptyQuestionnaire(selectedQId);
            setButtonText("Save");
         }
      }
    } catch (error) {
      console.error("Error retrieving questionnaire response:", error);
    }

    // Update formik + local state
    setSelectedQuestionnaire(selectedQId);
    formik.setFieldValue("questionResponse", questionResponse);
    setInitialQuestionnaireResponse(questionResponse);
    setTextEditorKey((prevKey) => prevKey + 1);
    // Finally, set or reset "canEdit" for the newly selected Q
    setCanEditSelectedQuestionnaire(true);
  };

  const handleEndSession = async () => {
    // Enforce "Save" if required
    if (questionnaireList?.length > 0) {
      let QRid = formik?.values?.questionResponseId;
      // if (!QRid && (!formik.values?.questionResponse || formik.values.questionResponse.length === 0)) {
      //   failed("Save questionnaire before proceeding");
      //   return;
      // }
    if(!isQuestionnaireCompleted){
      failed("Save questionnaire before proceeding");
      return;
    }
    const currentQuestionnaire = isIntakeQuestionnaire 
        ? intakeQuestionnaireDefinition 
        : questionnaireList.find(q => q.id === selectedQuestionnaire);
        
    for (let i = 0; i < formik.values?.questionResponse.length; i++) {
        const item = formik.values?.questionResponse[i];
        
        
        const questionnaireItem = currentQuestionnaire?.item?.find(q => q.id === item.questionId);
        const isVisible = !questionnaireItem?.enableWhen || 
                        evaluateCondition(questionnaireItem.enableWhen.expression, formik.values.questionResponse);
        
        
        if (isVisible && item.required && !isAnswered(item)) {
          formik.setErrors({ isQuestionsError: `Question : ${item.question} is mandatory.` });
            return;
        }
    }
    } else {
      if (!formik.values?.questionResponse || formik.values.questionResponse.length === 0) {
        failed("Save questionnaire before proceeding");
        return;
      }
    }
    resetQuestionnaire();
    if (encounterFinished) {
      const url = `/app/encounter-details?encounterId=${state?.encounterId}`;
      navigate(url, { replace: true });
      return;
    }
    setIsLoading(true);
    setLoadingText("Ending Session");

    localStorage.removeItem("userJoined");
    if (state?.isWaitingRoom) {
      endWaitingRoomMeeting({ id: state?.id, patientId: state?.patientId })
        .then((res) => success(res.message))
        .catch((err) => console.log(err));
    }
    
    try {
      if (appointmentData || appointmentData?.id) {
        try {
          const res = await updateAppointmentRequest({
            encounterId: state?.encounterId,
            id: appointmentData.id,
            status: "completed",
            patientId,
            practitionerId,
            sessionToken: "",
          });
  
          if (res?.status) {
            setEncounterFinished(true);
          }
        } catch (err) {
          console.error("Error updating appointment:", err?.response?.data?.message || err?.response?.data?.error || err?.message);
        }
      } else {
        setEncounterFinished(true);
      } 
      navigate(`/app/encounter-details?encounterId=${state?.encounterId}`, { replace: true });
    } catch (err) {
      console.error("Unexpected error:", err);
    } finally {
      setIsLoading(false);
      setLoadingText(false);
    }
  };

  // Load the organization data
  useEffect(() => {
    getOrganization(adminOrgs?.[0]?.id)
      .then((res) => setOrganization(res.data))
      .catch((res) => {
        failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
      });
  }, [adminOrgs]);

  // On mount, fetch org's assigned questionnaires + existing QRs
  useEffect(() => {
    const fetchData = async () => {
      try {
        const orgRes = await getOrganization(encounterRecord?.orgId);
        const assigned = orgRes?.data?.assignedQuestionnaire || {};
        const videoVisitIds = assigned["video-visit"] || [];
        let questionnaireIdsList = [];
        if ("video-visit" in assigned && videoVisitIds.length > 0) {
          const VVRes = await getVideoVisitQuestionnaire(JSON.stringify(videoVisitIds), orgId);
          const modifiedData = VVRes?.data?.map((item) => ({
            ...item,
            name: item.title,
            value: item.id
          }));
          if (intakeQuestionnaireId) {
            modifiedData.push({
                id: 'Intake Questions',
                name: 'Intake Questions',
                value: 'Intake Questions'
            });
          }
          questionnaireIdsList = modifiedData.map(item => item.id);
          setQuestionnaireList(modifiedData);
        }

        const responseData = await getEncounterQuestionnaireResponses({ encounterId });
        if(intakeQuestionnaireId){
          let filteredData = responseData.data
          .filter((r) => r.id === intakeQuestionnaireId)
          filteredData = filteredData.length > 0 ? filteredData[0] : null;
          setIntakeQuestionnaire(filteredData);
          
          if (filteredData?.questionnaire && encounterRecord?.orgId) {
            try {
              const questionnaireDef = await getQuestionnaireById(filteredData.questionnaire, encounterRecord.orgId);
              setIntakeQuestionnaireDefinition(questionnaireDef?.data);
              
              const convertedResponse = setPreviousQuestionnaire(filteredData);
              setIntakeQuestionResponse(convertedResponse);
            } catch (error) {
              console.error('Error fetching intake questionnaire definition:', error);
            }
          }
        }
        setSavedQuestionnaireResponses(responseData);
          // If we had an in-progress state
          if (previousStatus?.startsWith("in-progress")) { 
            if ( responseData && Array.isArray(responseData.data) && responseData.data.every(item => typeof item.updatedAt === "number") ) {
              // Sort data by `updatedAt` in descending order to get the latest questionnaire
              const sortedData = [...responseData.data].sort((a, b) => b.updatedAt - a.updatedAt);
              const latestQuestionnaireId = sortedData?.[0]?.questionnaire; 
              if (!questionnaireIdsList.includes(latestQuestionnaireId) || !latestQuestionnaireId) return; 
           
              // Filter records with the latest questionnaire ID and sort by `authored`
              const filteredData = responseData.data
                  .filter(record => record.questionnaire === latestQuestionnaireId)
                  .sort((a, b) => b.authored - a.authored);
          
              const latest = filteredData.length > 0 ? filteredData[0] : null;
              let questionResponse = [];
          
              if (latest?.item?.length > 0) {
                  const canEdit = checkCanEditAuthor(latest);
                  questionResponse = canEdit
                      ? setPreviousQuestionnaire(latest)  // Use previous questionnaire if the author is the same
                      : setEmptyQuestionnaire(latestQuestionnaireId); // Otherwise, blank it out
          
                  if (canEdit) {
                      formik.setFieldValue("questionResponseId", latest.id);
                      setSelectedQuestionnaire(latestQuestionnaireId);
                      setInitialQuestionnaireResponse(questionResponse);
                      setButtonText("Update"); 
                  }
              } else { 
                  // Brand new blank questionnaire
                  questionResponse = setEmptyQuestionnaire(latestQuestionnaireId);
              }
              setCanEditSelectedQuestionnaire(true);
              formik.setFieldValue("questionResponse", questionResponse);
            } 
          } 
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [adminOrgs, encounterId, previousStatus, orgId, intakeQuestionnaireId]);

  const resetQuestionnaire = () => {
    formik.resetForm();
    setSelectedQuestionnaire('');
  };


  const handleView = () => {
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/app/patients-details?patientId=${patientId}`//&patientName=${patientName}`;
    window.open(url, "_blank");
  };

  // PARK
  const handleParkCallClick = () => {
    if (questionnaireList?.length > 0) {
      let QRid = formik?.values?.questionResponseId;
      // if (!QRid && (!formik.values?.questionResponse || formik.values.questionResponse.length === 0)) {
      //   failed("Save questionnaire before proceeding");
      //   return;
      // }
    if(!isQuestionnaireCompleted){
      failed("Save questionnaire before proceeding");
      return;
    }
    const currentQuestionnaire = questionnaireList.find(q => q.id === selectedQuestionnaire);
          
    for (let i = 0; i < formik.values?.questionResponse.length; i++) {
        const item = formik.values?.questionResponse[i];
        
        
        const questionnaireItem = currentQuestionnaire?.item?.find(q => q.id === item.questionId);
        const isVisible = !questionnaireItem?.enableWhen || 
                        evaluateCondition(questionnaireItem.enableWhen.expression, formik.values.questionResponse);
        
        
        if (isVisible && item.required && !isAnswered(item)) {
          formik.setErrors({ isQuestionsError: `Question : ${item.question} is mandatory.` });
            return;
        }
    }
    } else {
      if (!formik.values?.questionResponse || formik.values.questionResponse.length === 0) {
        failed("Save questionnaire before proceeding");
        return;
      }
    }
    formik.handleSubmit();

    setIsLoading(true);
    setLoadingText("Loading...");

    const utcString = new Date().toISOString().split(".")[0] + ".00Z";

    if (state?.appointmentData) {
      const requestedPeriod = [{
        start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
        end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
      }];
      return updateAppointmentRequest({
        encounterId: state?.encounterId,
        id: state?.appointmentData?.id,
        status: "completed",
        patientId,
        practitionerId,
        sessionToken: ""
      })
        .then(async (res) => {
          if (res?.status === true) {
            const actor = {
              display: practionerData.name[0].text,
              reference: `Practitioner/${myUserId}`,
            };
            let questionnareResponses = appointmentData?.intakeQuestions;
            let newResponseAdded = questionnareResponses ? {
              ...questionnareResponses,
              intakeCommunicationChannel: "phone",
              intakeReason: appointmentData?.intakeQuestions?.reason,
              intakeAssignedPractitioner: {
                individual: {
                  display: practionerData?.name[0]?.text,
                  reference: `Practitioner/${myUserId}`,
                  type: "Practitioner"
                },
                period: { start: utcString, end: null }
              }
            } : {};

            await axios.put(`encounter/${state?.encounterId}`, {
              status: "parked",
              actor,
              requestedPeriod,
              class: "NULL",
              intakeQuestions: newResponseAdded
            });
            success("Appointment successfully parked");
            navigate("/app/dashboard");
          }
        })
        .catch((err) => console.log(err?.response?.data?.message || err?.response?.data?.error || err?.message))
        .finally(() => setIsLoading(false));

    } else {
      // Non-appointment scenario
      const currentActor = {
        reference: `Practitioner/${myUserId}`,
        display: practUserName,
        type: "Practitioner",
      };
      let encounterIntakeQuestions = {
        ...encounterRecord?.intakeQuestions,
        intakeCommunicationChannel: "phone",
        intakeAssignedPractitioner: {
          individual: {
            display: practionerData?.name[0]?.text,
            reference: `Practitioner/${myUserId}`,
            type: "Practitioner"
          },
          period: { start: utcString, end: null }
        }
      };
      const syncedParticipants = syncMissingParticipantsFromStatusHistory(
        encounterRecord?.participant || [],
        encounterRecord?.statusHistory || []
      );

      let encounterPayload = {
        patient: encounterRecord?.subject,
        orgId: encounterRecord?.orgId,
        orgName: encounterRecord?.serviceProvider?.display || encounterRecord?.managingOrganization?.display,
        questionnairInfo: encounterIntakeQuestions,
        requestedPeriod: encounterRecord?.requestedPeriod,
        practitionerId: encounterRecord?.practitionerId,
        practitionerName: practUserName,
        proceedWith: encounterRecord?.proceedWith,
        status: "parked",
        encounterId: encounterRecord?.id,
        patientLocation: encounterRecord?.patientLocation,
        participant: syncedParticipants,
        actor: currentActor,
        encounterClass: "NULL"
      };

      let oldPractHistory = queueRecord?.practitionerHistory;
      if (oldPractHistory) {
        let parkingPractitioner = {
          actor: {
            display: practionerData?.name[0]?.text,
            reference: `Practitioner/${myUserId}`,
            type: "Practitioner"
          },
          assignedBy: {
            actor: {
              display: practionerData?.name[0]?.text,
              reference: `Practitioner/${myUserId}`,
              type: "Practitioner"
            },
          },
          updatedAt: Date.now()
        };
        const updatedPractitionerHistory = [...oldPractHistory, parkingPractitioner];
        editQueueItem({ id: queueRecord?.id, practitionerHistory: updatedPractitionerHistory }, orgId)
          .catch((res) => {
            failed(res?.response?.data?.message || res?.response?.data?.error || res?.message);
          });
      }

      editEncounter(encounterPayload)
        .then((res) => {
          if (res?.status === true) {
            success("Encounter Parked Successfully");
            navigate("/app/dashboard");
          }
        })
        .catch((res) => {
          failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
        })
        .finally(() => setIsLoading(false));
    }
  };

  // FOLLOW-UP
  const handleFollowUpClick = () => {
    if (questionnaireList?.length > 0) {
      let QRid = formik?.values?.questionResponseId ;
      // if (!QRid && (!formik.values?.questionResponse || formik.values.questionResponse.length === 0)) {
      //   failed("Save questionnaire before proceeding");
      //   return;
      // }

    if(!isQuestionnaireCompleted){
            failed("Save questionnaire before proceeding");
            return;
    }
    const currentQuestionnaire = questionnaireList.find(q => q.id === selectedQuestionnaire);
          
    for (let i = 0; i < formik.values?.questionResponse.length; i++) {
        const item = formik.values?.questionResponse[i];
        
        
        const questionnaireItem = currentQuestionnaire?.item?.find(q => q.id === item.questionId);
        const isVisible = !questionnaireItem?.enableWhen || 
                        evaluateCondition(questionnaireItem.enableWhen.expression, formik.values.questionResponse);
        
        
        if (isVisible && item.required && !isAnswered(item)) {
          formik.setErrors({ isQuestionsError: `Question : ${item.question} is mandatory.` });
            return;
        }
    }
    } else {
      if (!formik.values?.questionResponse || formik.values.questionResponse.length === 0) {
        failed("Save questionnaire before proceeding");
        return;
      }
    }

    formik.handleSubmit();
    setIsLoading(true);
    setLoadingText("Loading...");

    if (state?.appointmentData) {
      const requestedPeriod = [{
        start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
        end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
      }];
      return updateAppointmentRequest({
        encounterId: state?.encounterId,
        id: state?.appointmentData?.id,
        status: "completed",
        patientId,
        practitionerId,
        sessionToken: ""
      })
        .then(async (res) => {
          if (res?.status === true) {
            const actor = {
              display: practionerData.name[0].text,
              reference: `Practitioner/${myUserId}`,
            };
            let questionnareResponses = appointmentData?.intakeQuestions;
            let newResponseAdded = questionnareResponses ? {
              ...questionnareResponses,
              intakeCommunicationChannel: "phone",
              intakeReason: appointmentData?.intakeQuestions?.reason
            } : {};
            await axios.put(`encounter/${state?.encounterId}`, {
              status: "follow-up",
              actor,
              requestedPeriod,
              class: "NULL",
              intakeQuestions: newResponseAdded
            });
            success("Appointment added to Follow-Up");
            navigate("/app/dashboard");
          }
        })
        .catch((err) => console.log(err?.response?.data?.message || err?.response?.data?.error || err?.message))
        .finally(() => setIsLoading(false));

    } else {
      const currentActor = {
        reference: `Practitioner/${myUserId}`,
        display: practUserName,
        type: "Practitioner",
      };
      let encounterIntakeQuestions = {
        ...encounterRecord?.intakeQuestions,
        intakeCommunicationChannel: "phone"
      };
      let encounterPayload = {
        patient: encounterRecord?.subject,
        orgId: encounterRecord?.orgId,
        orgName: encounterRecord?.serviceProvider?.display || encounterRecord?.managingOrganization?.display,
        questionnairInfo: encounterIntakeQuestions,
        requestedPeriod: encounterRecord?.requestedPeriod,
        practitionerId: encounterRecord?.practitionerId,
        practitionerName: practUserName,
        proceedWith: encounterRecord?.proceedWith,
        status: "follow-up",
        encounterId: encounterRecord?.id,
        patientLocation: encounterRecord?.patientLocation,
        participant: encounterRecord?.participant,
        actor: currentActor,
        encounterClass: "NULL"
      };
      setIsLoading(true);
      editEncounter(encounterPayload)
        .then((res) => {
          if (res?.status === true) {
            success("Encounter Added to Follow-Up");
            navigate("/app/dashboard");
          }
        })
        .catch((res) => {
          failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleScheduleAppointmentClick = () => {
    setScheduleAppointmentModalOpen(true);
  };

  const handleProtocolAssessmentClick = () => {
    setLoadingText("Loading...")
    setIsLoading(true);
    getProtocolResponsesByEncounterId(encounterId, encounterRecord?.orgId || orgId)
      .then((res) => {
        const parsedResponse = JSON.parse(res?.body);
        if (parsedResponse?.data && parsedResponse?.data?.length > 0) {
          const baseUrl = window.location.origin;
          const url = `${baseUrl}/app/protocol-assessment?encounterId=${encounterId}`;
          window.open(url, "_blank");
        } else {
          let payload = {
            resourceType: "ProtocolResponse",
            status: "in-progress",
            encounterId: encounterId,
            orgId: encounterRecord?.orgId,
            authored: moment().toISOString(),
            author: 
              {
                display: practionerData.name[0].text,
                reference: `Practitioner/${myUserId}`,
                type: "Practitioner"
              },
              authorId: myUserId,
              encounter: {
                reference: `Encounter/${encounterId}`
              },
              managingOrganization: {
                reference: `Organization/${encounterRecord?.orgId}`,
                type: "Organization"
              },
              subject: encounterRecord?.subject
            }
          createProtocolResponse(encounterRecord?.orgId, payload)
            .then((res) => {
              setTriageBtnState(false);
              setShowTriageComponent(true);
              setProtocolResponseWasUpdated(true);
            })
          }
        })
      .catch((res) =>
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
              res.message
        )
      )
      .finally(() => setIsLoading(false)) 
    }
  
  const hideTriageBtn = () => {
    setTriageBtnState(false);
  };

  useEffect(() => {
    if (isContactCenterActive && Array.isArray(permissions) && permissions.includes("Read Protocol Response") && encounterRecord?.orgId) {
      getProtocolResponsesByEncounterId(encounterId, encounterRecord?.orgId)
        .then((res) => {
          const parsedResponse = JSON.parse(res?.body);
          if (parsedResponse?.data?.length > 0) {
            setShowTriageComponent(true);
          }
        })
    }
  }, [encounterRecord]);


  const renderIntakeQuestions = (intakeQuestions) => {
    // Convert intake response to questionResponse format for APL evaluation
    const questionResponse = setPreviousQuestionnaire(intakeQuestions);
    
    // Filter questions based on APL rules
    const filteredItems = intakeQuestions.item?.filter((data) => {
      if (!intakeQuestionnaireDefinition) return true; // Show all if no definition loaded
      
      // Match by id or linkId
      const questionnaireItem = intakeQuestionnaireDefinition?.item?.find(q => 
        q.id === data.id || 
        q.id === data.linkId || 
        q.linkId === data.id || 
        q.linkId === data.linkId
      );
      if (!questionnaireItem?.enableWhen) return true; // Show if no condition
      
      // Evaluate the condition using the converted questionResponse
      return evaluateCondition(questionnaireItem.enableWhen.expression, questionResponse);
    });

    return filteredItems?.map((data) => (
        <>
        {data?.answer?.[0]?.valueString && (
          <div className="accordion-view-block mt-2" key={data?.linkId}>
            <div className="header-accordion p-3 pt-2 pb-2">
              {data?.text}
            </div>
            <div className="body-accordion p-3">
              <div className="m-0" dangerouslySetInnerHTML={{__html: `${data?.answer?.[0]?.valueString}`}} />
            </div>
          </div>
        )}
        {data?.questionType === "radio" && (
          data?.answer?.some(ele => ele?.valueBoolean === true) && (
            <div className="accordion-view-block mt-3" key={data?.linkId}>
              <div className="header-accordion p-3 pt-2 pb-2">
                {data?.text}
              </div>
              <div className="body-accordion p-3">
                <div className="m-0">
                  {data?.answer?.map(ele => (
                    ele?.valueBoolean === true && (
                      <div key={ele.id}>{ele?.option}</div>
                    )
                  ))}
                </div>
              </div>
            </div>
          )
        )}
        {data?.questionType === "checkbox" && (
          data?.answer?.some(ele => ele?.valueBoolean === true) && (
            <div className="accordion-view-block mt-3" key={data?.linkId}>
              <div className="header-accordion p-3 pt-2 pb-2">
                {data?.text}
              </div>
              <div className="body-accordion p-3">
                <div className="m-0">
                  {data?.answer?.map(ele => (
                    ele?.valueBoolean === true && (
                      <div key={ele.id}>{ele?.option}</div>
                    )
                  ))}
                </div>
              </div>
            </div>
          )
        )}
        </>
    ));
  };

  const getHcnValue = (data) => {
    let hcnValue;
    if(data ){
        for (let i = 0; i < data?.identifier?.length; i++) {    
            if (data?.identifier[i].type === "HCN") {      
                hcnValue = data?.identifier[i].value;
                break;
            }
        }
    }
    return hcnValue;
  }

  return (
    encounterDetailsShow ? (
      <EncounterDetail
        setEncouterDetailsShow={setEncouterDetailsShow}
        EncounterId={state?.encounterId}
        PatientId={patientId}
        PractionerData={practionerData}
        PractitionerId={myUserId}
        ShowCompleteButton={true}
      />
    ) : (
      <div>
        <section className={triageBtnState ? "common-listing" : "common-listing-v2"}>
          {isLoading && <FullPageSpinner loadingText={loadingText} />}
          {scheduleAppointmentModalOpen && (
            <ScheduleAppointmentWR
              onShow={scheduleAppointmentModalOpen}
              onHide={() => setScheduleAppointmentModalOpen(false)}
              encounterId={encounterId}
              questionnaireData={questionnairInfo}
              patientName={patientName}
              patientId={patientId}
              questionnaireResponseId={savedQuestionResponseId}
            />
          )}

          <div className='patient-info'>
            <div className='patient-info-container'>
              <div className='patient-info-grid'>
                <div className='info-column'>
                  <div className='info-item'><strong>Patient:</strong> <span>{capitalizeWords(patientData?.name?.[0]?.text) || "-"}</span></div>
                  <div className='info-item'><strong>Patient Identifier:</strong> <span>{getHcnValue(patientData) || "-"}</span></div>
                </div>
                <div className='info-column'>
                  <div className='info-item'><strong>Age:</strong> <span>{ViewDate(patientData?.birthDate) + " - " + safeAgeString(patientData?.birthDate)}{patientData?.gender && ` - ${capitalizeWords(patientData?.gender)}`}</span></div>
                  <div className='info-item'><strong>Contact:</strong> <span>{questionnairInfo?.callerNumber || "-"} {questionnairInfo?.callerNumberExt && `ext. ${questionnairInfo?.callerNumberExt}`}</span></div>
                </div>
                <div className='info-column'>
                  <div className='info-item'><strong>Organization:</strong> <span>{(encounterRecord?.serviceProvider?.display) || (encounterRecord?.managingOrganization?.display) || "-"}</span></div>
                  <div className='info-item'><strong>Service Line:</strong> <span>{encounterRecord?.serviceLine?.display || "-"}</span></div>
                </div>
              </div>
              {encounterRecord?.intakeQuestions?.callerRelationship !== "Self" && (
                <div className='patient-info-row-2'>
                  <div className='info-item'><strong>Caller Name:</strong> <span>{capitalizeWords(questionnairInfo?.callerName ) || "-"} </span></div>
                  <div className='info-item'><strong>Relationship:</strong> <span>{capitalizeWords(encounterRecord?.intakeQuestions?.callerRelationship) || "-"}</span></div>
                </div>
              )}
            </div>
            <div >
              {!state?.isWaitingRoom && (
                <div className="right-wrap">
                  <Resources
                    show={resourceModalShow}
                    onHide={() => setResourceModalShow(false)}
                    serviceLineId={encounterRecord?.serviceLineId}
                    encounterOrgId={encounterRecord?.orgId}
                  />
                  <Button
                    className="custom-btn"
                    title="Open Dashboard in a new tab"
                    variant="primary"
                    onClick={() => handleView()}
                  >
                    Patient Dashboard
                  </Button>
                  {hasResourcesReadPermissions && <Button className="custom-btn" 
                    title="Resources"
                    variant="primary"
                    onClick={() => setResourceModalShow(true)}>
                      Resources
                  </Button>}
                   {isVirtualCare && ( <Button
                    className="custom-btn"
                    title="Schedule Appointment"
                    variant="primary"
                    onClick={() => handleScheduleAppointmentClick()}
                  >
                    Schedule Appointment
                  </Button>
                  )}

                  {isVirtualCare && permissions.includes("Create Prescriptions") && (
                    <Button
                      className="custom-btn ms-2"
                      title="Create Prescription"
                      variant="primary"
                      style={{ padding: "0" }}
                      onClick={() =>
                        organization?.sft?.enabled &&
                          (organization?.sft?.individualDelivery || organization?.sft?.locationDelivery)
                          ? handleMedicationRequest()
                          : organization?.sft?.enabled &&
                            !organization?.sft?.individualDelivery &&
                            !organization?.sft?.locationDelivery
                            ? failed("Please enable SFT delivery options.")
                            : failed("Please enable SFT to send document.")
                      }
                    >
                      <img src={medicalIcon} alt="Prescription" />
                    </Button>
                  )}

                  {isVirtualCare && Array.isArray(permissions) && (permissions.includes("Create Service Referrals") || permissions.includes("Create Lab Requisitions") || permissions.includes("Create Diagnostic Imaging Requests") )  && (
                    <Button
                      className="custom-btn ms-2"
                      title="Add Referral service request"
                      variant="primary"
                      style={{ padding: "0" }}
                      onClick={() =>
                        organization?.sft?.enabled &&
                          (organization?.sft?.individualDelivery || organization?.sft?.locationDelivery)
                          ? handleServiceRequest("Referral")
                          : organization?.sft?.enabled &&
                            !organization?.sft?.individualDelivery &&
                            !organization?.sft?.locationDelivery
                            ? failed("Please enable SFT delivery options.")
                            : failed("Please enable SFT to send document.")
                      }
                    >
                      <img src={referralIcon} alt="Referral" />
                    </Button>
                  )}

                  
                </div>
              )}
            </div>
          </div>


          <div className="questionnair-wrapper mt-5">
            <div className="heading-wrap h-change" style={{ display: 'flex', alignItems: 'center' }}>
              <h1 className="big-head">Questionnaire</h1>
            </div>
            <hr />
            <div className="chat-sidebar">
              <div className="individual-chart-wrap">
                <div
                  className="chat-body common-form"
                  style={{ paddingTop: "1rem", justifyContent: "center", alignItems: "center" }}
                >
                  {/* Dropdown is always active so user can switch questionnaires */}
                  <SelectFiled
                    keyField="questionnaire"
                    label="Select Questionnaire"
                    formik={formik}
                    onChange={handlePrompt}
                    value={selectedQuestionnaire}
                    options={questionnaireList}
                  />
                  <hr />

                  {/* Pass a readOnly flag if user is not the original author */}
                  {!isIntakeQuestionnaire && formik.values.questionResponse && formik.values.questionResponse.length > 0 && (
                    <QuestionnaireRenderer
                      key={textEditorKey}
                      formik={formik}
                      questionResponse={formik.values.questionResponse}
                      questionnaire={questionnaireList.find(x => x.id === selectedQuestionnaire)}
                      readOnly={!canEditSelectedQuestionnaire}
                    />
                  )}

                  {isIntakeQuestionnaire && intakeQuestionnaire && (
                    <div>
                        {renderIntakeQuestions(intakeQuestionnaire)}
                    </div>
                  )}
                </div>

                <div className="msg-footer">
                  <div
                    className="btn-wrap"
                    style={{ display: 'flex', justifyContent: "end", gap: "1rem", alignItems: "center" }}
                  >
                    {!isReleaseDisabled && (
                      <>
                        <Button 
                          type="button" 
                          onClick={handleReleaseEncounter}
                          title="Release encounter and return to queue"
                          variant="secondary"
                        >
                          Release
                        </Button>
                        <div className="button-separator"></div>
                      </>
                    )}
                    {/* Only show Save/Update if user can edit this questionnaire */}
                    {canEditSelectedQuestionnaire && (
                      <>
                        <Button
                          type="submit"
                          isLoading={btnLoading}
                          onClick={formik.handleSubmit}
                          style={{
                            background: 'linear-gradient(90deg, #4CAF50 0%, #388E3C 100%)'
                          }}
                        >
                          {buttonText} 
                        </Button>
                        <div className="button-separator"></div>
                      </>
                    )}
                    
                    {(isContactCenterActive && 
                      Array.isArray(permissions) && permissions.includes("Write Protocol Response") && triageBtnState) && (
                      <>
                        <Button 
                          type="button"
                          isLoading={btnLoading} 
                          onClick={handleProtocolAssessmentClick} 
                          title="Triage">
                            Triage
                        </Button>
                        <div className="button-separator"></div>
                      </>
                    )}

                    

                    <Button type="button" onClick={handleParkCallClick}>
                      Park Call
                    </Button>
                    <Button type="button" onClick={handleFollowUpClick}>
                      Add to Follow-Up
                    </Button>

                    <div className="button-separator"></div>
                    <Button
                        type="button"
                        onClick={handleEndSession}
                      >
                        Proceed
                    </Button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
        {/* Protocol Assessment Component */}
        {(isContactCenterActive && permissions.includes("Write Protocol Response") && showTriageComponent) && <section className='common-listing-v2'>
          <div className="questionnair-wrapper-v2">
            <div className="heading-wrap h-change" style={{ display: 'flex', alignItems: 'center' }}>
              <h1 className="big-head">Protocol Assessment</h1>
            </div>
            <hr />
            <TriageParentComponent 
              encounterIdFromVisit={encounterId} 
              fetchResponses={triageBtnState}
              setProtocolResponseWasUpdated={setProtocolResponseWasUpdated} 
              hideTriageBtn={hideTriageBtn} 
            /> 
          </div>
        </section>}
      </div>
    )
  );
}

export default PhoneCallCreate;
